"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var ArtworkContext = /*#__PURE__*/_react["default"].createContext({
  isGenerated: true,
  data: null,
  initialConfiguration: null,
  configuration: null,
  setConfiguration: null,
  onChange: null,
  setData: null,
  onDataChange: null,
  isAuthorOrAdmin: null,
  translate: null
});
var _default = ArtworkContext;
exports["default"] = _default;